import React from 'react';
import { Box, Typography, Avatar, Card, Tooltip } from '@mui/material';
import { width } from '@mui/system';

const ResourceStatusDot = ({ status }) => {
  let color = '';
  let text = '';

  switch (status) {
    case 'Active':
      color = '#34C759'; // Green
      text = 'Active';

      break;
    case 'On Leave':
      color = '#FF3B30'; // Red
      text = 'On Leave';

      break;
    default:
      color = '#9E9E9E'; // Gray for unknown
      text = 'Unknown';

  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", width: "100%" }}>
      <Box
        sx={{
          width: 6,
          height: 6,
          bgcolor: color,
          borderRadius: '50%',
          //   flexShrink: 5,   
        }}
      />
      <Typography
        variant="caption"
        sx={{ color: color, fontWeight: 600, fontSize: '8px' }}
      >
        {text}
      </Typography>
    </Box>
  );
};

const ResourceRow = ({ resource }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      mb: 1,
      gap: 1,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>

      <Typography
        variant="body2"
        sx={{ fontWeight: 500, fontSize: '12px' }}
      >
        {resource.resource}
      </Typography>
    </Box>
    <Tooltip title={resource.role} arrow>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          minWidth: 90,
          fontSize: "10px",
        }}
      >
        {resource.role.length > 10
          ? resource.role.substring(0, 10) + "..."
          : resource.role}
      </Typography>
    </Tooltip>
    <Typography
      variant="body2"
      sx={{ fontWeight: 500, minWidth: 60, fontSize: '12px' }}
    >
      {resource.total_rpi}
    </Typography>
  </Box>
);

const ProjectDashboardCardDev = ({ currentPhase, resources }) => {
  return (
    <Card
      sx={{
        width: '100%',
        borderRadius: 3,
        boxShadow: 3,
        bgcolor: '#fff',
        p: 2,
        height: '200px'
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ mb: 1, fontWeight: 'bold', color: '#243465', fontSize: '12px' }}
      >
        Current Phase:
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mb: 1,
          color: '#30496B',
          fontWeight: 600,
        }}
      >
        <Typography
          variant="caption"
          sx={{ minWidth: 120, fontWeight: 'bold', color: '#124580', fontSize: '10px' }}
        >
          Resource Name
        </Typography>
        <Typography
          variant="caption"
          sx={{ minWidth: 70, fontWeight: 'bold', color: '#124580', fontSize: '10px' }}
        >
          Role
        </Typography>
        <Typography variant="caption" sx={{ minWidth: 60, fontWeight: 'bold', color: '#124580', fontSize: '10px' }}>
          RPI
        </Typography>
      </Box>
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          scrollbarWidth: 'none', // Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari
          },
        }}
      >
        {resources.map((resource) => (
          <ResourceRow key={resource.resource} resource={resource} />
        ))}
      </Box>
    </Card>
  );
};

export default ProjectDashboardCardDev;
